module.exports = __webpack_public_path__ + "img/fullscreen.e29e0087.png";